import { useState, useEffect, createContext, useContext } from "react";
import MapApi from "../api/map";
import useCallApi from "../hooks/useCallApi";
import { useUser } from "./UserContext";

type GoogleMapsApiKey = string | null;

type ContextState = {
  googleMapsApiKey: GoogleMapsApiKey;
  loading: boolean;
  error: boolean;
};

const initialValues = {
  googleMapsApiKey: null,
  loading: false,
  error: false
};

type IProps = {
  children: React.ReactElement<any, any> & React.ReactNode;
};

export const GoogleMapsApiKeyContext = createContext<ContextState>(initialValues);

export const GoogleMapsApiKeyProvider: React.FC<IProps> = ({ children }) => {
  const { token } = useUser();
  const { callApi, loading, error } = useCallApi();
  const [googleMapsApiKey, setGoogleMapsApiKey] = useState<GoogleMapsApiKey>(null);

  useEffect(() => {
    if (!token) {
      return;
    }

    if (googleMapsApiKey) {
      return;
    }

    callApi(MapApi.getGoogleMapsApiKey(), ({ googleMapsApiKey }: { googleMapsApiKey: GoogleMapsApiKey }) => {
      setGoogleMapsApiKey(googleMapsApiKey);
    });
  }, [callApi, token, googleMapsApiKey]);

  return (
    <GoogleMapsApiKeyContext.Provider value={{ googleMapsApiKey, loading, error }}>
      {children}
    </GoogleMapsApiKeyContext.Provider>
  );
};

export const useMap = () => useContext(GoogleMapsApiKeyContext);
